import { z } from 'zod';

export const createEmptyContact = () => ({ name: '', email: '', phone: '', subject: '', message: '' });
const requiredMessage = 'Lutfen ad, e-posta ve mesaj alanlarini doldurunuz.';

export const contactSchema = z.object({
  name: z.string().trim().min(1, requiredMessage).max(120, 'Ad Soyad en fazla 120 karakter olabilir.'),
  email: z.string().trim().min(1, requiredMessage).email('Lutfen gecerli bir e-posta adresi giriniz.'),
  phone: z.string().trim().max(40, 'Telefon en fazla 40 karakter olabilir.'),
  subject: z.string().trim().max(200, 'Konu en fazla 200 karakter olabilir.'),
  message: z.string().trim().min(1, requiredMessage).max(2000, 'Mesaj en fazla 2000 karakter olabilir.'),
});

export const getContactPayload = (values) => ({
  ...values, phone: values.phone || null, subject: values.subject || null,
});

export const getContactError = (error) => {
  if (error.response?.status === 422) return 'Lutfen bilgileri kontrol edin.';
  if (error.code === 'ECONNABORTED') return 'Baglanti zaman asimina ugradi. Lutfen tekrar deneyin.';
  return 'Mesajiniz gonderilemedi. Lutfen tekrar deneyin.';
};